import {
  isValid,
} from 'date-fns';
import qs from 'qs';
import { ProfileStatus } from 'src/types/UserInfo';
import {
  SelectedFiltersStateType, FilterLabels, DateRangeType, SortByType,
} from './types';

export const getHasReplies = (replies: string) => {
  if (replies === FilterLabels.hasReplies) return true;
  if (replies === FilterLabels.hasNoReplies) return false;
  return undefined;
};

export const getHasSolution = (quickFilters: Array<string>) => {
  if (quickFilters.includes(FilterLabels.hasSolution)) return true;
  return undefined;
};

export const getAmazonReplied = (quickFilters: Array<string>) => {
  if (quickFilters.includes(FilterLabels.hasAmazonReply)) return true;
  return undefined;
};

export const getQueryForUserId = ({
  quickFilters,
  userId,
}: {
  quickFilters: Array<string>;
  userId: string;
}) => {
  if (quickFilters.includes(FilterLabels.userId)) return userId;
  return undefined;
};

const validateSearchTerm = (searchTermValue: any) => {
  if (typeof searchTermValue === 'string') {
    return searchTermValue;
  }
  if (
    Array.isArray(searchTermValue)
    && searchTermValue.every((term) => typeof term === 'string')
  ) {
    return searchTermValue.join(',');
  }
  return undefined;
};

const validateField = (
  parsedContent: any,
  validEntries: string[],
  isArray: boolean,
) => {
  if (typeof parsedContent === 'string' && validEntries.includes(parsedContent)) {
    return isArray ? [parsedContent] : parsedContent;
  }

  if (
    Array.isArray(parsedContent)
    && parsedContent.every((content) => typeof content === 'string')
  ) {
    const validParsedContent = parsedContent.filter((content) => validEntries.includes(content));
    return validParsedContent.length > 0 ? validParsedContent : undefined;
  }
  return undefined;
};

export const getFiltersFromURL = ({
  categoriesList,
  tagsList,
  profileStatus,
}: {
  categoriesList: Array<string>,
  tagsList: Array<string>,
  profileStatus: ProfileStatus,
}) => {
  const query = qs.parse(decodeURIComponent(window.location.search.slice(1)), {
    comma: true,
  });

  const {
    dateRange,
    quickFilters,
    replies,
    categories,
    tags,
    searchTerm,
    sortBy,
    startDate,
    endDate,
  } = query;
  const validatedSortBy = validateField(sortBy, Object.values(SortByType), false);
  const allowedSortByValue = validatedSortBy === SortByType.relevance
    && profileStatus !== ProfileStatus.registered
    ? SortByType.totalViews : validatedSortBy;
  const validatedDateRange = validateField(dateRange, Object.values(DateRangeType), false);
  const validatedQuickFilters = validateField(
    quickFilters,
    [FilterLabels.hasAmazonReply, FilterLabels.userId, FilterLabels.hasSolution],
    true,
  );
  const validatedReplies = validateField(
    replies,
    [FilterLabels.repliesAll, FilterLabels.hasReplies, FilterLabels.hasNoReplies],
    false,
  );
  const validatedCategories = validateField(categories, categoriesList, true);
  const validatedTags = validateField(tags, tagsList, true);
  const validatedSearchTerm = validateSearchTerm(searchTerm);
  const parsedStartDate = parseInt(startDate as string, 10);
  const parsedEndDate = parseInt(endDate as string, 10);
  const validatedStartDate = isValid(parsedStartDate) ? parsedStartDate : undefined;
  const validatedEndDate = isValid(parsedEndDate) ? parsedEndDate : undefined;

  return {
    sortBy: allowedSortByValue as SelectedFiltersStateType['sortBy'] | undefined,
    dateRange: validatedDateRange as SelectedFiltersStateType['dateRange'] | undefined,
    quickFilters: validatedQuickFilters as SelectedFiltersStateType['quickFilters'] | undefined,
    replies: validatedReplies as SelectedFiltersStateType['replies'] | undefined,
    categories: validatedCategories as SelectedFiltersStateType['categories'] | undefined,
    tags: validatedTags as SelectedFiltersStateType['tags'] | undefined,
    searchTerm: validatedSearchTerm as SelectedFiltersStateType['searchTerm'] | undefined,
    startDate: validatedStartDate,
    endDate: validatedEndDate,
  };
};
